import { getProveedores, createProveedor, updateProveedor, deleteProveedor } from '../models/proveedorModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchProveedores(page, perPage) {
  try {
    const response = await getProveedores(page, perPage);
    return {
      proveedor: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching proveedores:", error);
    Swal.fire('Error', 'No se pudieron cargar los proveedores', 'error');
    return null;
  }
}

export async function saveProveedor(proveedor, currentProveedorId) {
  try {
    if (currentProveedorId) {
      await updateProveedor(currentProveedorId, proveedor);
      toasts.add({
        title: 'Éxito',
        description: 'Proveedor actualizado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      await createProveedor(proveedor);
      toasts.add({
        title: 'Éxito',
        description: 'Proveedor creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
  } catch (error) {
    console.error("Error saving proveedor:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el proveedor',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

export async function removeProveedor(id) {
  try {
    await deleteProveedor(id);
    toasts.add({
      title: 'Éxito',
      description: 'Proveedor eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting proveedor:", error);
    Swal.fire('Error', 'No se pudo eliminar el proveedor', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'proveedor'
export function subscribeToProveedores(searchQuery, handleSearch) {
  pb.collection('proveedor').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(); // Actualiza la lista manteniendo la página actual
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromProveedores() {
  pb.collection('proveedor').unsubscribe('*');
}

export async function searchProveedores(query, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('proveedor').getList(page, perPage, {
      filter: `nombre ~ "${query}" || apellido ~ "${query}" || email ~ "${query}" || telefono ~ "${query}" || direccion ~ "${query}" || nit ~ "${query}" || dpi ~ "${query}" || observaciones ~ "${query}"`,
    });
    return {
      proveedor: response.items,
      totalRecords: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching proveedores:", error);
    Swal.fire('Error', 'No se pudieron buscar los proveedores', 'error');
    return null;
  }
}
